import Api from './axiosInstance'
import { API_CRON_JOBS } from 'utils/constants/apiPath'
import { CronJobFilters } from 'types/cronJob'

// List of scheduled jobs; blank filters are left out
export const fetchCronJobs = (filters: CronJobFilters = {}) => {
  const params = new URLSearchParams()

  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.append(key, value)
  })

  return Api.get({ url: `${API_CRON_JOBS.LIST}?${params}` })
}

// Sets a stuck job back to idle so it can run again
export const resetCronJob = (name: string) =>
  Api.post({ url: API_CRON_JOBS.RESET(name) })

// Changes a job's cron expression, on/off switch and/or limit overrides
export const updateCronJob = (
  name: string,
  // null for a limit clears its override (back to automatic)
  data: {
    expression?: string
    isActive?: boolean
    maxRunMinutes?: number | null
    maxGapMinutes?: number | null
  },
) => Api.patch({ url: API_CRON_JOBS.UPDATE(name), data })
